import { createContext } from "react";

export const LanguageContext = createContext();
export const HEBROW = 0
export const ENGLISH = 1